// src/core/socketIo.js
import { io } from 'socket.io-client';

const socket = io('https://promxa.com:3030', {
  transports: ['websocket'],
  reconnection: true,
  autoConnect: false,
  secure: true,
});



socket.on('connect', () => {
  console.log('✅ Socket connected:', socket.id);
    
});

socket.on('disconnect', () => {
  console.log('❌ Socket disconnected');
});
export default socket;
